(function () {
	'use strict';

	angular.module('app.leanProjects')
		.directive('scoringChart', scoringChart);

	function scoringChart($compile, $filter, $window, $timeout, $translate, $rootScope,
			numberFormatService, fullPageChart, leanFilterService, $experiments) {
		return {
			link: function (scope, elem, attr) {
				var chart;
				var initListener;
				var w = angular.element($window);
				var windowHeight = 0;

				w.bind('resize', function () {
					windowHeight = fullPageChart.resizeChart('assessmentScoringChart');
					if (chart)
						chart.resize({
							height: windowHeight
						});
				});

				function init() {
					var hbCont = jQuery('#handlebarContainer').length;
					var supplierPortal = globalConfig.user.role === 'Supplier';
					var gridLoaded = jQuery('#assessmentScoringChart').length;
					if (globalConfig && globalConfig.factory && gridLoaded) {
						jQuery('#handlebarContainer').bind('leftNavChanged', function () {
							windowHeight = fullPageChart.resizeChart('assessmentScoringChart');
							generateChart();
						});
						windowHeight = fullPageChart.resizeChart('assessmentScoringChart');
						generateChart();
					} else {
						$timeout(function () {
							init();
						}, 10);
					}
				}

				var chartFormatters = {
					rating: numberFormatService.getWithParameters
				};

				var chartColorMap = {
					rating: 'rgb(45,193,113)'
				};

				function chartColors(color, d) {
					var id = d;
					if (typeof d.id !== 'undefined')
						id = d.id;

					return chartColorMap[id];
				}

				function getFormattedData() {
					var chartData = {};
					chartData.categories = [];
					chartData.columns = [
						['rating']
					];

					for (var i = 0; i < scope.rawData.length; i++) {
						chartData.categories.push(scope.rawData[i]['systemNameText']);
						chartData.columns[0].push(scope.rawData[i].rating);
					}
					return chartData;
				}

				function generateChart() {
					if (!scope.rawData) return;
					var chartData = getFormattedData(scope.rawData);
					var config = {
						bindto: '#' + elem[0].id,
						point: {
							r: 4
						},
						data: {
							columns: chartData.columns,
							type: 'bar',
							axes: {
								rating: 'y'
							},
							names: {
								rating: 'Lean System'
							},
							color: chartColors,
							labels: {
								format: function (d) {
									return numberFormatService.getWithParameters(d, 2);
								}
							}
						},
						axis: {
							x: {
								type: 'category',
								tick: {
									rotate: -60,
									multiline: false,
									culling: {
										max: 500
									},
									outer: false
								},
								height: 200,
								categories: chartData.categories
							},
							y: {
								tick: {
									format: function (d) {
										return numberFormatService.getWithParameters(d, 2);
									},
									values: [0, 1, 2, 3, 4, 5],
									count: 5
								},
								min: 0,
								max: 5,
								padding: {
									bottom: 0,
									top: 10
								},
								label: {
									text: 'Score (1-Low to 5-High)',
									position: 'outer-middle'
								}
							}
						},
						grid: {
							y: {
								show: true
							}
						},
						size: {
							height: windowHeight
						},
						tooltip: {
							format: {
								value: function (value, ratio, id) {
									return chartFormatters[id](value, 2);
								}
							}
						}
					};
					chart = c3.generate(config);
					fullPageChart.paintRect(elem[0], chartColorMap.rating);
				}

				initListener = $rootScope.$on('assessmentScoringDataReady', function (event) {
					init();
				});

				scope.$on('$destroy', function () {
					if (chart) {
						chart.destroy();
					}
					if (initListener) {
						initListener();
					}
				});
			}
		};
	}
})();
